import { HostServiceListContainer } from "./containers/HostServiceListContainer"

interface HostServicesSectionProps {
    marketSpyId?: number
    monitorLaunchTaskResult: any
}

export const HostServicesSection = (props: HostServicesSectionProps): JSX.Element => {
    const {
        marketSpyId,
        monitorLaunchTaskResult,
    } = props

    return (
        <div>
            <HostServiceListContainer
                marketSpyId={marketSpyId}
                monitorLaunchTask={monitorLaunchTaskResult}
            />     
        </div>
    )
}